
import React from "react";
import Btn from "./common/Btn";
import { i18nManager } from "../i18n";
import PageHead from "./common/PageHead";
import ProductCard from "./common/ProductCard";
import FilterChips from "./common/FilterChips";
import styles from "../assets/style.module.css";
import { IMerchItem, MERCH } from "../data";

export interface StoreProps {
    cart: IMerchItem[];
    onAddToCart: (item: IMerchItem) => void;
}

function Store({ cart, onAddToCart }: StoreProps) {

    const labels = i18nManager.Labels.store;
    const [category, setCategory] = React.useState("");
    const categories = Array.from(new Set(MERCH.map((m) => m.category)));

    return (<>
        <PageHead kicker={labels.kicker} title={labels.title} subtitle={labels.desc} />
        <section className={styles["section-page"]}>
            <div className={styles["container"]}>
                <FilterChips value={category} onChange={setCategory} options={[["", i18nManager.Labels.home.all], ...categories.map((c) => [c, c] as [string, string])]} />
                <div className={styles["product-grid"]}>
                    {MERCH.filter((m) => !category || m.category === category).map((item) => {
                        const added = cart.some((c) => c.id === item.id);
                        return (<ProductCard key={item.id} item={item} action={
                            <Btn size="sm" variant={added ? "outline" : "primary"} onClick={() => onAddToCart(item)}>{added ? (<><i className="fa fa-check" /> {labels.added}</>) : labels.add_to_cart}</Btn>
                        } />);
                    })}
                </div>
            </div>
        </section>
    </>);
}

export default Store;
